import { Overlay } from '@vfde-brix/ws10/overlay';
import {
    OverlayAction,
    OverlayContent,
} from './enum';
import { ContainerActions } from '../../interface';

/**
 * Initializes Overlay, triggers overlay html fetches
 */
export const initOverlay = (overlay: Overlay) => ({
    type: OverlayAction.INIT,
    overlay,
} as const);

/**
 * Starts the loading spinner on the overlay
 */
export const startLoadingOverlay = (id: ContainerActions) => ({
    type: OverlayAction.START_LOADING,
    id,
} as const);

/**
 * Stops the loading spinner on the overlay
 */
export const stopLoadingOverlay = (id: ContainerActions) => ({
    type: OverlayAction.STOP_LOADING,
    id,
} as const);

/**
 * Sets if overlay htmls are loaded
 */
export const setOverlayLoaded = () => ({
    type: OverlayAction.LOADED,
} as const);

/**
 * Opens/closes overlay with desired content
 */
export const setOverlayVisibility = (
    isVisible: boolean,
    activeContent: OverlayContent = OverlayContent.AVC,
) => ({
    type: OverlayAction.SET_OVERLAY_VISIBILITY,
    isVisible,
    activeContent,
} as const);

/**
 * Opens overlay with desired content
 */
export const setOverlayContent = (
    activeContent: OverlayContent,
) => ({
    type: OverlayAction.SET_OVERLAY_CONTENT,
    activeContent,
} as const);

/**
 * Action for triggering canceling active avc check on overlay close
 */
export const cancelAvailabilityCheck = () => ({
    type: OverlayAction.CANCEL_AVAILABILITY_CHECK,
} as const);

/**
 * Action for triggering prevent of cancel avaibility check (seamless flow)
 */
export const preventCancel = () => ({
    type: OverlayAction.PREVENT_CANCEL,
} as const);

/**
 * Overlay Actions
 */
export type Actions = ReturnType<typeof initOverlay>
    | ReturnType<typeof setOverlayLoaded>
    | ReturnType<typeof setOverlayVisibility>
    | ReturnType<typeof startLoadingOverlay>
    | ReturnType<typeof stopLoadingOverlay>
    | ReturnType<typeof setOverlayContent>
    | ReturnType<typeof preventCancel>
    | ReturnType<typeof cancelAvailabilityCheck>;
